import { Button, Flex, Progress, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiArrowRight, FiCheckSquare } from "react-icons/fi";
import type { BuyerPublicBidDetailDto } from "../../../../autogen/bff-api";
import { SectionCard } from "../../../sourcing-events/portal/view-single/SectionCard";
import { getBidQualificationProgress } from "./bidQualification";

interface Props {
  detail: BuyerPublicBidDetailDto;
  onOpenQualifications: () => void;
}

export const QualificationProgressCard = ({ detail, onOpenQualifications }: Props) => {
  const { t } = useTranslation();
  const { fulfilled, total, progress, hasRequirements } = getBidQualificationProgress(detail);
  const title = t("Qualification requirements");
  const progressText = t("{{fulfilled}} of {{total}} fulfilled", { fulfilled, total });

  return (
    <SectionCard icon={FiCheckSquare} title={title}>
      <Stack spacing="4">
        {hasRequirements ? (
          <>
            <Flex justify="space-between" align="center" gap="3">
              <Text fontSize="sm" color="smText" fontWeight="semibold">
                {progressText}
              </Text>
              <Text fontSize="sm" color="smMuted" fontFamily="mono">
                {fulfilled}/{total}
              </Text>
            </Flex>
            <Progress
              value={progress}
              size="sm"
              rounded="full"
              colorScheme={fulfilled === total && total > 0 ? "green" : "teal"}
              aria-label={title}
              aria-valuetext={progressText}
            />
          </>
        ) : (
          <Text fontSize="sm" color="smMuted">
            {t("No qualification requirements")}
          </Text>
        )}
        <Button
          size="sm"
          variant="ghost"
          colorScheme="teal"
          rightIcon={<FiArrowRight />}
          alignSelf="flex-start"
          onClick={onOpenQualifications}
        >
          {t("See all requirements")}
        </Button>
      </Stack>
    </SectionCard>
  );
};
